// extracted by mini-css-extract-plugin
export default {"works":"Works_works__WDlf7","h1":"Works_h1__4SdB6","cards":"Works_cards__87QFm","shrunkCardsContainer":"Works_shrunkCardsContainer__4uKA2"};